(function() {
  'use strict';

  angular
    .module('app')
    .controller('UploadDetailsController', function($scope, $stateParams, cfpLoadingBar, UploadQueueService) {
      UploadQueueService.getUploadDetailsPageModel({
        id: $stateParams.id
      })
        .then(function(pageModel) {
          Object.assign($scope, pageModel);
          $scope.pageModel = pageModel;
        })
        .finally(function() {
          cfpLoadingBar.complete();
        });

      $scope.getJson = function() {
        return JSON.stringify($scope.pageModel, null, 2);
      };
    });
})();
